module.exports = __webpack_public_path__ + "static/media/dark2.f5b08d7d.jpg";